import PropTypes from 'prop-types';
import React from 'react';
import 'react-phone-number-input/style.css';
import Input from 'react-phone-number-input';
import styled from 'styled-components';
import { ErrorText, Label } from './styles';

export const Container = styled.div`
  font-size: 14px;
  & .PhoneInput {
    background: ${(props) => props.theme.colors.white};
    border-color: ${(props) => props.theme.colors['border-input']};
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    padding: 0.4em 0.8em;
    box-sizing: border-box;
    & .PhoneInputInput {
      border: none;
      color: ${(props) => props.theme.colors.secondary};
      background: ${(props) => props.theme.colors.white};
      font-family: Roboto;
      box-shadow: none;
      outline: none;
      min-width: 0;
      text-align: center;
      margin: 1px;
      padding: 1px;
      font-size: 16px;
      font-weight: 600;
    }
    & .PhoneInputInput::placeholder {
      word-spacing: -3px;
      letter-spacing: 3px;
      font-size: 36px;
      font-weight: 800;
    }

    &.PhoneInput--focus {
      border-color: ${(props) => props.theme.colors.primary};
      .PhoneInputInput {
        outline: none;
      }
    }
    .PhoneInputCountry {
      box-shadow: none;
    }
  }
`;

export const PhoneInput = props => {
  const { className, error, inputClassName, label, onCountryChange, ...rest } = props;
  return (
    <Container className={className}>
      {label && <Label>{label}</Label>}
      <Input
        {...rest}
        className={inputClassName}
        addInternationalOption={false}
        defaultCountry="US"
        countryOptionsOrder={['US', 'CA', 'GB', 'MX', 'AU', '|', '...']}
        onCountryChange={onCountryChange}
      />
      {error && <ErrorText>{error}</ErrorText>}
    </Container>
  );
};
PhoneInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  label: PropTypes.string,
};
